export default __webpack_public_path__ + "static/media/roma-intro.62671ece.mp4";